import _ from 'underscore';
import { trim } from 'underscore.string';
import { InsertionOrderColumns } from '@bingads-webui-campaign/reports-v4-component';
import { addInsertionOrderIdFilter } from '../../helpers/insertion-order-helper';


const operatorToApi = {
  $eq: 'Equals',
  $neq: 'DoesNotEqual',
  $gt: 'GreaterThan',
  $gte: 'GreaterThanEqual',
  $in: 'Equals',
  $lt: 'LessThan',
  $lte: 'LessThanEqual',
  $contains: 'Contains',
  $containsany: 'Contains',
  $doesnotcontain: 'DoesNotContain',
  $startswith: 'BeginsWith',
  $endswith: 'EndsWith',
};

const operatorFromApi = {
  Equals: '$eq',
  DoesNotEqual: '$neq',
  GreaterThan: '$gt',
  GreaterThanEqual: '$gte',
  LessThan: '$lt',
  LessThanEqual: '$lte',
  Contains: '$contains',
  DoesNotContain: '$doesnotcontain',
  BeginsWith: '$startswith',
  EndsWith: '$endswith',
};

function batchToString(arr) {
  return _.map(arr, x => String(x));
}

function apiToUiFormat(apiFilter, filterSchema) {
  const {
    Filter: {
      Expressions: [
        Expression,
      ],
    },
  } = apiFilter;
  const propertyName = Expression.PropertyName;
  const propertySchema = filterSchema[propertyName];
  const propertyValuesApi = Expression.Values;
  const operatorApi = Expression.Operator;
  let propertyValueUi;
  let operatorUi;

  if (propertyName === InsertionOrderColumns.InsertionOrderId) {
    propertyValueUi = propertyValuesApi;
    operatorUi = operatorFromApi[operatorApi];
  } else if (propertySchema.enum) {
    propertyValueUi = propertyValuesApi.map(enumValue => `Enum.${propertyName}'${enumValue}'`);
    operatorUi = '$in';
  } else if (propertySchema.type === 'string') {
    propertyValueUi = propertyValuesApi.join(',');
    operatorUi = operatorFromApi[operatorApi];
  } else if (['integer', 'percent', 'float'].includes(propertySchema.type)) {
    propertyValueUi = Number(propertyValuesApi[0]);
    operatorUi = operatorFromApi[operatorApi];
  }

  return {
    [propertyName]: {
      [operatorUi]: propertyValueUi,
    },
  };
}


function uiToApiFormat(uiFilter, filterSchema) {
  const propertyName = _.keys(uiFilter)[0];
  const propertySchema = filterSchema[propertyName];
  const propertyValueObject = uiFilter[propertyName];
  const operatorUi = _.keys(propertyValueObject)[0];
  let propertyValueUi = [];
  if (propertyName === InsertionOrderColumns.InsertionOrderId) {
    propertyValueUi = propertyValueObject[operatorUi];
  } else if (propertySchema.enum) {
    propertyValueUi = propertyValueObject[operatorUi].map((str) => {
      const start = str.indexOf('\'');
      const end = str.length;
      return str.substr(start + 1, end - start - 2);
    });
  } else if (propertySchema.type === 'string') {
    propertyValueUi = propertyValueObject[operatorUi].split(',').map(x => trim(x));
  } else if (['integer', 'percent', 'float'].includes(propertySchema.type)) {
    propertyValueUi = [propertyValueObject[operatorUi]];
  }

  const result = {
    Filter: {
      LogicalOperator: 'OR',
      Expressions: [
        {
          '@odata.type': '#Model.Predicate',
          PropertyName: propertyName,
          Operator: operatorToApi[operatorUi],
          Values: batchToString(propertyValueUi),
        },
      ],
    },
  };

  return result;
}

export function uiToApiFilter(uiFilters, entitySchema, insertionOrderSelectorValue) {
  const filterSchema = entitySchema.Filters.properties;
  const uiFiltersArray = addInsertionOrderIdFilter({ oldFilter: uiFilters, insertionOrderIds: insertionOrderSelectorValue });
  if (!uiFiltersArray || _.isEmpty(uiFiltersArray)) return [];
  let apiFilters = [];
  if (uiFiltersArray.$and) {
    apiFilters = _.map(uiFiltersArray.$and, uiFilter => uiToApiFormat(uiFilter, filterSchema));
  } else {
    apiFilters = [uiToApiFormat(uiFiltersArray, filterSchema)];
  }
  return apiFilters;
}

export function apiToUiFilter(taskItem, entitySchema) {
  const apiFilters = taskItem.Filters;
  const filterSchema = entitySchema.Filters.properties;
  if (!apiFilters || _.isEmpty(apiFilters)) return {};
  let uiFilters = apiToUiFormat(apiFilters[0], filterSchema);
  if (apiFilters.length > 1) {
    uiFilters = { $and: [] };
    uiFilters.$and = apiFilters.map(apiFilter => apiToUiFormat(apiFilter, filterSchema));
  }
  return uiFilters;
}
